<!--
    Implements software requirements: SRS-215

    Cannot be dismissed: only a reload loads the other session's changes before this one saves.
-->
<script setup lang="ts">
    import { storeToRefs } from 'pinia';
    import { useCaseSyncStore } from '@/stores/useCaseSyncStore';
    import { STALE_CASE_MESSAGE } from '@/api/caseVersion';

    const { isStale } = storeToRefs(useCaseSyncStore());

    const reloadPage = () => {
        window.location.reload();
    };
</script>

<template>
    <app-modal persistent :model-value="isStale" max-width="600" color="planner-grey-light">
        <v-card>
            <app-modal-title>Reload this case</app-modal-title>

            <app-modal-content>
                <div class="px-0">{{ STALE_CASE_MESSAGE }}</div>
            </app-modal-content>

            <app-modal-actions>
                <v-row class="ma-2 mb-0">
                    <v-spacer></v-spacer>
                    <app-button-primary class="ml-2" @click="reloadPage">
                        Reload case
                    </app-button-primary>
                </v-row>
            </app-modal-actions>
        </v-card>
    </app-modal>
</template>
